export const apiUrls = {
  privilegesList: `/v1/privileges-list`,
  rolesList: (search: string): string =>
    `/v1/roles-list${search ? `?search=${search}` : ""}`,
  raceList: (search: string): string =>
    `/v1/race-list${search ? `?search=${search}` : ""}`,
  veteranStatusList: (search: string): string =>
    `/v1/veteran-statuses-list${search ? `?search=${search}` : ""}`,
  certificationsList: (search: string): string =>
    `/v1/certifications${search ? `?search=${search}` : ""}`,
  skillcategory: (search: string): string =>
    `/v1/skill-cagegories${search ? `?search=${search}` : ""}`,
  careersList: (search: string): string =>
    `/v1/careers${search ? `?search=${search}` : ""}`,
  careerPath: (search: string): string =>
    `/v1/career-path${search ? `?search=${search}` : ""}`,
  careerCategory: (search: string): string =>
    `/v1/career-categories${search ? `?search=${search}` : ""}`,
  educationTrainingList: (search: string): string =>
    `/v1/education-trainings${search ? `?search=${search}` : ""}`,
  educationLevelsList: (search: string): string =>
    `/v1/education-levels${search ? `?search=${search}` : ""}`,
  generalQuestion: (search: string): string =>
    `/v1/general-questions${search ? `?search=${search}` : ""}`,
  experienceList: (search: string): string =>
    `/v1/experiences${search ? `?search=${search}` : ""}`,
  occupationalGroups: (search: string): string =>
    `/v1/occupational-groups${search ? `?search=${search}` : ""}`,
};
